//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    enabled: { type: Boolean, required: true },
    border: { type: Boolean, default: false }
  },
  computed: {
    icon () {
      return this.enabled ? 'checkmark' : 'pencil'
    }
  }
}
